/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

// note: if not defined schema in ./src/api/client/override/schema need to change value by action response schema
export enum API_TYPES {
  countries = 'CountryResponse',
  languages = 'LanguageResponse',
  myCompanyDetails = 'MyCompanyDetailsResponse',
  glassesDetails = 'GlassesDetailsResponse',
  subscriptionPlans = 'subscriptionPlans',
  states = 'StateResponse',
  myCompanyInfo = 'myCompanyInfo',
  companyCountriesResidence = 'CompanyCountryResidenceResponse',
  userCountriesResidence = 'UserCountryResidenceResponse',
  appConfig = 'appConfig',
  cancelationReasons = "cancelationReasons",
  recaptchaWhiteList = 'recapthcaWhiteList'
}

// entities which won't be removed after logout
export const NOT_SECURE_API_TYPES = [
  API_TYPES.languages,
  API_TYPES.appConfig,
  API_TYPES.recaptchaWhiteList,
]
